<template>
    <section v-if="images" class="!pointer-events-auto relative h-[950px] md:h-[1300px] overflow-hidden">
        <div data-aos="fade-in" data-aos-duration="2000" class="h-[130px] w-[190px] md:h-[350px] md:w-[500px] rounded !absolute !top-[60px] !left-[60px] md:!left-[calc(50%-500px)] overflow-hidden">
            <img class="w-full h-full object-cover" :src="images[0]" alt="">
        </div>

        <div data-aos="fade-in" class="h-[90px] w-[85px] md:h-[240px] md:w-[230px] rounded absolute !top-[150px] md:!top-[270px] !left-[20px] md:!left-[calc(50%-630px)] overflow-hidden">
            <img class="w-full h-full object-cover" :src="images[1]" alt="">
        </div>

        <div data-aos="fade-in" data-aos-duration="2400" class="h-[150px] w-[230px] rounded absolute !top-[220px] !right-[calc(50%-750px)] overflow-hidden">
            <img class="w-full h-full object-cover" :src="images[5]" alt="">
        </div>

       <MoleculeAnarchiveTitle class="pt-[280px] md:pt-[500px]"/>

        <p class="text-center w-2/3 mx-auto mt-5 md:max-w-xl">{{ $t('home.anarchiveText') }}</p>

        <AtomButtonExplore :to="{ name: 'anarchive' }" />

        <div data-aos="fade-in" data-aos-duration="2700" class="h-[235px] w-[370px] rounded absolute !bottom-[285px] !left-[calc(50%-770px)] overflow-hidden">
            <img class="w-full h-full object-cover" :src="images[6]" alt="">
        </div>

        <div data-aos="fade-in" data-aos-duration="2000" class="h-[100px] w-[105px] md:h-[220px] md:w-[230px] rounded absolute !bottom-[130px] !left-[-20px] md:!left-[calc(50%-480px)] overflow-hidden">
            <img class="w-full h-full object-cover" :src="images[2]" alt="">
        </div>

        <div data-aos="fade-in" class="h-[70px] w-[75px] md:h-[215px] md:w-[230px] rounded absolute !bottom-[235px] md:!bottom-[600px] !right-[40px] md:!right-[calc(50%-500px)] overflow-hidden z-10">
            <img class="w-full h-full object-cover" :src="images[3]" alt="">
        </div>

        <div data-aos="fade-in" data-aos-duration="1500" class="h-[125px] w-[120px] md:h-[380px] md:w-[370px] rounded absolute !bottom-[125px] md:!bottom-[280px] !right-[-45px] md:!right-[calc(50%-770px)] overflow-hidden">
            <img class="w-full h-full object-cover" :src="images[4]" alt="">
        </div>
    </section>
</template>

<script>
import AtomSectionSeparator from "../../global/atoms/AtomSectionSeparator.vue";
import AtomButtonExplore from "../../global/atoms/AtomButtonExplore.vue";
import {mapActions} from "vuex";
import MoleculeAnarchiveTitle from "../../global/molecules/MoleculeAnarchiveTitle.vue";

export default {
    name: 'OrganismHomeAnarchive',
    components: {MoleculeAnarchiveTitle, AtomButtonExplore, AtomSectionSeparator},
    data(){
        return{
            events: null
        }
    },
    computed: {
        images() {
            return this.events?.map(event => event.cover.cached_url)
        }
    },
    methods: {
        ...mapActions('event', ['getRandoms']),
        getRandomEvents() {
            this.getRandoms(7).then((result) => this.events = result)
        },
    },
    mounted() {
        this.getRandomEvents();
    },
}
</script>
